// todo: Ensure that tags are synced with the filter // todo: click x event on
search bar // todo: sort out actions header css
<template>
  <div class="">
    <section class="title">
      <div class="header__text-box">
        <h1 class="heading-primary">
          <span class="heading-primary--main">Blog Management </span>
        </h1>
      </div>
    </section>
    <Crumbs />
    <section class="section-about-landing" style="padding-top: 0rem">
      <div class="row">
        <ag-grid-vue
          style="width: 123rem; height: 200px"
          class="ag-theme-material"
          :column-defs="columnDefs"
          :row-data="blogs_merged"
          :frameworkComponents="frameworkComponents"
        />
      </div>
      <btn-cell-renderer />
    </section>
  </div>
</template>
<script>
import Crumbs from '@/components/layout/Crumbs'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-material.css'
import BtnCellRenderer from '@/components/shared/btn-cell-renderer.vue'
import { AgGridVue } from 'ag-grid-vue'
import {
  getFirebaseCollectionWhere,
  getPostTags
} from '@/functions/firebase/base'

export default {
  name: 'BlogManagement',
  components: {
    Crumbs,
    AgGridVue,
    BtnCellRenderer
  },

  data() {
    return {
      blogs: [],
      blog_tags: [],
      projects: [],
      project_tags: [],
      rowData: []
    }
  },

  beforeMount() {
    this.frameworkComponents = {
      btnCellRenderer: BtnCellRenderer
    }
  },

  setup() {
    return {
      columnDefs: [
        { headerName: 'Title', field: 'data.title' },
        { headerName: 'Tags', field: 'tags' },
        { headerName: 'Slug', field: 'data.slug_name' },
        { headerName: 'Actions' },
        {
          field: 'scope',
          resizable: true,
          sortable: true,
          headerName: 'Delete',
          cellRenderer: 'btnCellRenderer',
          cellRendererParams: {
            clicked(field) {
              alert(`deleted`)
            }
          }
        }
      ]
    }
  },

  computed: {
    blogs_merged() {
      return this.blogs.map((item, index) => {
        return {
          ...item,
          tags: this.blog_tags[index]
        }
      })
    }
  },
  mounted() {
    Promise.all([this.getAllBlogs()])
  },

  methods: {
    async getAllBlogs() {
      getFirebaseCollectionWhere(
        process.env.VUE_APP_DB_BLOGS,
        'project',
        false
      ).then((result) => {
        this.blogs = result
        this.blogs.forEach((element) => {
          getPostTags(element.id).then((tags) => {
            if (tags.length > 0) {
              this.blog_tags.push(tags)
            } else {
              this.blog_tags.push(['empty'])
            }
          })
        })
      })

      getFirebaseCollectionWhere(
        process.env.VUE_APP_DB_BLOGS,
        'project',
        true
      ).then((result) => {
        this.projects = result
        this.projects.forEach((element) => {
          getPostTags(element.id).then((tags) => {
            console.log(tags)
            if (tags.length > 0) {
              this.project_tags.push(tags)
            } else {
              this.project_tags.push(['empty'])
            }
          })
        })
      })
    }
  }
}
</script>

<style></style>
